import React from 'react';
import useAsync from 'hooks/globals/useAsync';
import Button from './Button';
import type IButtonWithStatus from './shared/types/buttonWithStatus';

const ButtonWithStatus = React.forwardRef<HTMLAnchorElement | HTMLButtonElement, IButtonWithStatus>(
    (
        {
            onClick: asyncFunction,
            onIdle,
            onPending,
            onSuccess,
            onError,
            status: explicitStatus,
            children,
            ...restProps
        },
        ref
    ) => {
        const { execute, status } = useAsync(asyncFunction, false);

        const statuses = {
            idle: onIdle,
            pending: onPending || onIdle,
            success: onSuccess || onIdle,
            error: onError || onIdle
        };

        return (
            <Button ref={ref} onClick={execute} {...restProps}>
                {statuses[explicitStatus || status]} {children}
            </Button>
        );
    }
);

export default ButtonWithStatus;
